import React from 'react'
import { Typography } from 'antd'
import { isArray, isEmpty, isNil, isString, toString } from 'lodash'

const isListOrStringEmpty = item =>
  (isString(item) || isArray(item)) && isEmpty(item)

const getEventDifferenceText = (
  differentKey,
  original,
  change,
  shouldComputeArrayDifferences = false,
  onClick,
) => {
  if (isArray(original) && shouldComputeArrayDifferences) {
    const addedItems = change.filter(item => !original.includes(item))
    const removedItems = original.filter(item => !change.includes(item))

    const fullText = `${differentKey}: ${
      isNil(original) || isListOrStringEmpty(original)
        ? 'No value'
        : toString(original)
    } -> ${
      isNil(change) || isListOrStringEmpty(change)
        ? 'No value'
        : toString(change)
    }`

    return (
      <>
        <Typography.Text onClick={() => onClick(fullText)}>
          {differentKey}:
          <br />
          {isEmpty(addedItems)
            ? 'No added items'
            : `Added items: ${toString(addedItems)}`}
          <br />
          {isEmpty(removedItems)
            ? 'No removed items'
            : `Removed items: ${toString(removedItems)}`}
        </Typography.Text>
      </>
    )
  }

  return `${differentKey}: ${
    isNil(original) || isListOrStringEmpty(original)
      ? 'No value'
      : toString(original)
  } -> ${
    isNil(change) || isListOrStringEmpty(change) ? 'No value' : toString(change)
  }`
}

export default getEventDifferenceText
